/** author：胡枭 */

// 页面缓存的全局状态
const state = {
  cachedViews: [],
  // 记录所有访问过的页面个数
  historyLength: 0
}

const mutations = {
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return

    if (view.meta.cache) {
      state.cachedViews.push(view.name)
    }
  },

  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    index > -1 && state.cachedViews.splice(index, 1)
  },

  DEL_ALL_CACHE_VIEWS: (state, view) => {
    state.cachedViews = []
  },

  INIT_HISTORY_LENGTH: (state) => {
    state.historyLength = Number(sessionStorage.getItem('historyLength') || 0)
  },

  ADD_HISTORY_LENGTH: (state, view) => {
    if (view.name) {
      state.historyLength += 1
      sessionStorage.setItem('historyLength', state.historyLength)
    }
  },

  DEL_HISTORY_LENGTH: (state) => {
    if (state.historyLength > 0) {
      state.historyLength -= 1
      sessionStorage.setItem('historyLength', state.historyLength)
    }
  },

  DEL_ALL_HISTORY_LENGTH: (state) => {
    state.historyLength = 0
    sessionStorage.setItem('historyLength', state.historyLength)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
